import React, { useContext } from 'react';
import get from 'lodash/get';
import { DataContext } from 'entries/common/widgets/context';
import { VolumeCell } from './volume-cell.component';
import { EmptyCell } from './empty-cell.component';

type TVolumeProps = {
  requiredVolume: string | undefined | null;
  isDoubleCell: boolean;
};

export const Volume: React.FC<TVolumeProps> = ({ requiredVolume, isDoubleCell }) => {
  const data = useContext(DataContext);
  const uom = get(data, 'additionalUomRus', '');
  const title = uom ? `${requiredVolume} ${uom}` : requiredVolume;

  return requiredVolume ? (
    <VolumeCell isDoubleCell={isDoubleCell} title={title as string} />
  ) : (
    <EmptyCell />
  );
};
